import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListPromotionModal from 'components/ListPromotionModal';
import * as selectors from 'state/profile/selectors';
import { PromoAfterItemUpload } from 'state/profile/constants';
import { startPromosAfterItemUpload } from 'state/profile/actions';
import ItemUploadFeedback from './ItemUploadFeedback';
import ItemUploadFeedbackNotification from './ItemUploadFeedbackNotification';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PromosAfterItemUpload = () => {
  const {
    0: isFeedbackNotificationOpen,
    1: setIsFeedbackNotificationOpen
  } = useState(false);
  const dispatch = useDispatch();
  const currentPromo = useSelector(selectors.getCurrentPromotion);
  useEffect(() => {
    dispatch(startPromosAfterItemUpload());
  }, [dispatch]);

  const handleNotificationShow = () => {
    setIsFeedbackNotificationOpen(true);
  };

  const closeNotification = () => {
    setIsFeedbackNotificationOpen(false);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [currentPromo === PromoAfterItemUpload.ListAnotherItem && /*#__PURE__*/_jsx(ListPromotionModal, {}), currentPromo === PromoAfterItemUpload.ItemUploadFeedback && /*#__PURE__*/_jsx(ItemUploadFeedback, {
      onClose: handleNotificationShow
    }), isFeedbackNotificationOpen && /*#__PURE__*/_jsx(ItemUploadFeedbackNotification, {
      handleClose: closeNotification
    })]
  });
};

export default PromosAfterItemUpload;